const LINK_COLOR = '#2563eb';
const LINK_REL = 'noopener noreferrer';
const LINK_TARGET = '_blank';
const TARGET_ATTRIBUTE = 'target';
const REL_ATTRIBUTE = 'rel';

export const TRUSTED_LINK_STYLE = `color:${LINK_COLOR}; text-decoration:underline;`;

export const hardenAnchor = (anchor: Element) => {
  anchor.setAttribute(TARGET_ATTRIBUTE, LINK_TARGET);
  anchor.setAttribute(REL_ATTRIBUTE, LINK_REL);
};
